import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';

const STATIC_URL = `${cdnPackagesUrl}/static/cloud/promo/personalization`;

enum PersonalizationSize {
    '256gb' = '256gb',
    '512gb' = '512gb',
    '1tb' = '1tb',
    '2tb' = '2tb',
    '4tb' = '4tb',
}

export const usePersonalizationSidebarImg = (space: number = 1) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);

    const getImageUrl = (size: PersonalizationSize) => {
        const theme = isDarkTheme ? 'Dark' : '';
        return `${STATIC_URL}/sidebarBanner/personalizationSidebarBanner${size}${theme}.png`;
    };

    switch (space) {
        case 256:
            return getImageUrl(PersonalizationSize['256gb']);
        case 512:
            return getImageUrl(PersonalizationSize['512gb']);
        case 2:
            return getImageUrl(PersonalizationSize['2tb']);
        case 4:
            return getImageUrl(PersonalizationSize['4tb']);
        case 1:
        default:
            return getImageUrl(PersonalizationSize['1tb']);
    }
};

export const openPersonalizationModal = () => openPopupHelper({ popupName: popupNames.PERSONALIZATION_MODAL, onClose: () => {} });
